module.exports = __webpack_public_path__ + "static/media/inter-latin-500-normal.64afe650.woff";